import React from "react";
import { Helmet } from "react-helmet";

const Meta = (props: any) => {
    return (
    <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1"/>
        <meta charSet="utf-8"/>

        <link rel="icon" href="/favicon.ico"/>
        <link rel="manifest" href="/manifest.json"/>

        <title>{props.title}</title>
    </Helmet>
)};

export default Meta;
